module.exports = __webpack_public_path__ + "static/media/Colette Wing King Headboard - 180 cm_Dark Blue.6a01e149.png";